import { get } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../../../../../utils/getGqlOperationName';
import orgGroupRolesSelectorQuery from './orgGroupRolesSelectorQuery.graphql';
const useAssigmentRoles = ({ orgGroupId, personEntityTypeId, }) => {
    const { data, error, loading } = useQuery(orgGroupRolesSelectorQuery, {
        variables: { orgGroupId, personEntityTypeId },
        skip: !personEntityTypeId || !orgGroupId,
    });
    const models = useMemo(() => get(data, getGqlOperationName(orgGroupRolesSelectorQuery), []), [data]);
    return { models, error, loading };
};
export default useAssigmentRoles;
